module.exports = __webpack_public_path__ + "img/preload_loading.1885df40.gif";